// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textColor": `#404041`,
	"colorRed": `#dd4e44`,
	"colorPink": `#ff1493`,
	"colorBlue": `#24b2e0`,
	"colorGreen": `#65c178`,
	"colorOrange": `#fa9961`,
	"colorYellow": `#e09f34`,
	"colorPurple": `#5841ab`,
	"colorDarkBlue": `#223c75`,
	"colorBrightBlue": `#3398d9`,
	"colorGoogle": `#4285f4`
};
export default ___CSS_LOADER_EXPORT___;
